import Axios from 'axios';
import server from 'util/Server';
import { IDatafono } from '../interfaces/GestionDatafonos.interfaces';


export const obtenerDatafonos = async (empresas_id: string) => {
    return Axios.get((server.host ?? '') + server.puertoCentury + `/api/datafonos`, { headers: { Authorization: server.obtenerToken() }, params: { empresas_id } })
}

export const crearDatafonos = async (body: IDatafono) => {
    return Axios.post((server.host ?? '') + server.puertoCentury + '/api/datafonos', body, { headers: { Authorization: server.obtenerToken() } })

}

export const editarDatafonos = async (body: any, id: number) => {
    return Axios.patch((server.host ?? '') + server.puertoCentury + `/api/datafonos/${id}`, body, { headers: { Authorization: server.obtenerToken() } })

}

export const cambiarEstadoDatafonos = async (body: any) => {
    return Axios.delete((server.host ?? '') + server.puertoCentury + `/api/datafonos/${body.id}?estado=${body.estado}`, { headers: { Authorization: server.obtenerToken() } })
}

export const obtenerEquiposAutoservicio = async (empresa_id: number) => {
    return Axios.get(`${server.host}${server.puertoAutoservicio}/api/v1/gestion-turnos/obtener-equipos?estacion_id=${empresa_id}`, { headers: { Authorization: server.obtenerToken() } })
}

export const obtenerDatosPuertosSeriales = async () => {
    return Axios.get(`${server.host}${server.puertoAutoservicio}/api/v1/gestion-puertos-seriales/listar`, { headers: { Authorization: server.obtenerToken() } })
}